import Permission from "../../permission";

export default class BulkPermissionCommand {
  public readonly resources: string[];
  public readonly granteeUserId: string;
  public readonly note?: string;
  public readonly replaceMatchingResourceTypes: boolean;

  public constructor(permissions: Permission[], replaceMatchingResourceTypes = false) {
    if (!permissions.length) {
      throw new Error("At least one permission is required.");
    }

    const firstGranteeUserId = permissions[0].granteeUserId;
    const firstNote = permissions[0].note;

    const allSameGranteeUserId = permissions.every(
      (permission) => permission.granteeUserId?.value === firstGranteeUserId?.value,
    );
    const allSameNote = permissions.every(p => p.note === firstNote);

    if (!allSameGranteeUserId || !allSameNote) {
      throw new Error("All permissions must have the same granteeUserId and note.");
    }

    this.resources = permissions.map(p => JSON.stringify(p.resource?.toJSON()));
    this.granteeUserId = firstGranteeUserId?.value;
    this.note = firstNote;
    this.replaceMatchingResourceTypes = replaceMatchingResourceTypes;
  }
}
